export const SET_SELF_CHECK_IN_DATA = 'SET_SELF_CHECK_IN_DATA';

export const SET_SCI_RESERVATION_ID = 'SET_SCI_RESERVATION_ID';
export const SET_SIGNATURE = 'SET_SIGNATURE';
export const SET_APPOINTMENT_NOTES = 'SET_APPOINTMENT_NOTES';
export const SET_SCI_MILEAGE = 'SET_SCI_MILEAGE';
export const SET_SCI_WAIT_STATE = 'SET_SCI_WAIT_STATE';
export const SET_SCI_MOBILE_NUMBER = 'SET_SCI_MOBILE_NUMBER';
export const SET_SCI_SIGNED = 'SET_SCI_SIGNED';
export const SET_SCI_PERSON_ID = 'SET_SCI_PERSON_ID';
export const SET_SELF_CHECKIN_STATUS = 'SET_SELF_CHECKIN_STATUS';
export const SET_STATUS_TRACKER_URL = 'SET_STATUS_TRACKER_URL';
export const SET_SCI_IS_NAVIGATING = 'SET_SCI_IS_NAVIGATING';
export const SET_SELF_CHECK_IN_FLOW = 'SET_SELF_CHECK_IN_FLOW';
export const SET_IS_DEALER_OPEN_NOW = 'SET_IS_DEALER_OPEN_NOW';
export const SET_SCI_LICENSE_NUMBER = 'SET_SCI_LICENSE_NUMBER';
export const SET_SCI_CAR_COLOR = 'SET_SCI_CAR_COLOR';
export const SET_SCI_TELL_US_MORE_ID = 'SET_SCI_TELL_US_MORE_ID';
export const UPDATE_SCI_ADDITIONAL_SERVICES = 'UPDATE_SCI_ADDITIONAL_SERVICES';
export const SET_INITIAL_LOADING_COMPLETE = 'SET_INITIAL_LOADING_COMPLETE';
export const UPDATE_SCI_ADDITIONAL_SERVICES_NOTES =
  'UPDATE_SCI_ADDITIONAL_SERVICES_NOTES';



// WEBPACK FOOTER //
// ./src/store/reducers/selfCheckIn/actionTypes.js